import {connect} from 'react-redux';
import compose from 'recompose/compose';
import withHandlers from 'recompose/withHandlers';
import includes from 'lodash/includes';
import get from 'lodash/get';
import {Types} from 'api/resources';
import {createResourcePageSelector} from 'resources/selectors';
import FilterBar from 'components/common/FilterBar';
import {
  exclusiveBreakFilterGroups,
  exclusiveRestrictedBreakFilterGroups,
  breakFilterGroups,
  restrictedBreakFilterGroups
} from 'utils/DBUtils';
import {createResourceNamedFiltersSelector} from 'viewOptions/selectors';
import {addFilterForResourceAction, removeFilterForResourceAction, removeAllFiltersForResourceAction} from 'viewOptions/actions';

const namedFiltersSelector = createResourceNamedFiltersSelector(Types.Challenge);
const getChallengeResourcePage = createResourcePageSelector(Types.Challenge);

const authorizedFilters = Object.freeze([
  'break_type_sponsored',
  'break_type_editorial'
]);

const mapStateToProps = (state) => {
  const namedFilters = namedFiltersSelector(state);
  const hasNamedFilter = (name) => includes(namedFilters, name);
  const { sortOptions, filterOptions } = getChallengeResourcePage(state.resources);

  const authorizedBreakTypes = get(state.userProfile.profile, 'userProfile.group.breakTypes', []);
  const canFilterByBreakType = ['sponsored', 'editorial'].every(type => includes(authorizedBreakTypes, type));

  const filterGroups = canFilterByBreakType ? breakFilterGroups : restrictedBreakFilterGroups;
  const exclusiveFilterGroups = canFilterByBreakType
    ? exclusiveBreakFilterGroups
    : exclusiveRestrictedBreakFilterGroups;

  return {
    resourceType: Types.Challenge,
    sortOptions,
    filterGroups,
    namedFilters,
    hasNamedFilter,
    canAddFilter: (name) => {
      const filterGroup = exclusiveFilterGroups.find(group => includes(group, name)) || [];
      const filterGroupAlreadyActive = filterGroup.filter(name => hasNamedFilter(name)).length > 0;

      return !filterGroupAlreadyActive;
    }
  };
};

const mapDispatchToProps = (dispatch) => ({
  addFilter: (name) => dispatch(addFilterForResourceAction(Types.Challenge, name)),
  onFilterDeselected: (name) => dispatch(removeFilterForResourceAction(Types.Challenge, name)),
  clearAllFiltersWithSortOptions: (sortOptions) => dispatch(removeAllFiltersForResourceAction(Types.Challenge, sortOptions))
});

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withHandlers({
    onFilterSelected: props => name => {
      if (props.canAddFilter(name)) {
        props.addFilter(name);
      }
    },
    clearAllFilters: props => () => props.clearAllFiltersWithSortOptions(props.sortOptions)
  })
)(FilterBar);



// WEBPACK FOOTER //
// ./public/pages/ListBreaks/BreakListFilterBar.jsx